import React from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';

export { TextFieldProps };
export default function TextField(props: TextFieldProps) {
  let { sx, ...others } = props;
  sx = sx || {};
  sx = {
    '& fieldset': {
      borderRadius: '32px',
    },
    ...sx,
  };
  return <MuiTextField sx={sx} {...others} />;
}
